import 'core-js/actual';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { windowLoad } from './loader.js';
import { Interface } from './interface.js';
import '../src/assets/css/dark/elements/alert.css';
import './views/database.js';
// import i18next from 'i18next';

// i18next.init({
//   lng: 'en',
//   resources: {
//     en: { translation: require('./lang/en.json') },
//     fr: { translation: require('./lang/fr.json') },
//   },
// });

const init = function () {
  windowLoad();
  window.addEventListener('load', function () {
    Interface.init('layout');
  });
  const currentYear = new Date().getFullYear();
  document.querySelector('.dynamic-year').textContent = currentYear;
};

init();
